/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionsContainer_settings = {
    readonly auth: {
        readonly integrations: {
            readonly sso: {
                readonly enabled: boolean;
                readonly targetFilter: {
                    readonly admin: boolean;
                };
            };
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"CopyCommentEmbedCodeContainer_settings">;
    readonly " $refType": "ModerationActionsContainer_settings";
};
export type ModerationActionsContainer_settings$data = ModerationActionsContainer_settings;
export type ModerationActionsContainer_settings$key = {
    readonly " $data"?: ModerationActionsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionsContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Auth",
            "kind": "LinkedField",
            "name": "auth",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthIntegrations",
                    "kind": "LinkedField",
                    "name": "integrations",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SSOAuthIntegration",
                            "kind": "LinkedField",
                            "name": "sso",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "enabled",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthenticationTargetFilter",
                                    "kind": "LinkedField",
                                    "name": "targetFilter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "admin",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CopyCommentEmbedCodeContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '606c29eb900e7b5629162d248be5676e';
export default node;
